import { useStore } from "..";
export const useDocumentLocale = () => useStore(({ documentLocale }) => documentLocale);
